import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/BannerSection';
import SidebarMenu from '../../components/SidebarMenu';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/BreadcrumbNav';

const caminho = [
  { label: 'Home', href: '/', icon: 'bi bi-house-door' },
  { label: 'Área Científica' },
  { label: 'Jornada Científica', href: '/investigacao/jornada' },
  { label: 'Submissão de Resumo' }
];

function JornadaCientifica() {

  const form = useRef();

  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const agora = new Date().toLocaleString("pt-PT");

  const enviarFormulario = (e) => {
    e.preventDefault();

    setLoading(true);

    emailjs.sendForm(
      "service_slsnxe7",
      "template_mt9jt27",
      form.current,
      "JLTmM-bpYmvRk5e1H",
      {
        time: agora
    }
    )
    .then(() => {
      setMensagem("Resumo enviado com sucesso!");
      form.current.reset();
    })
    .catch((error) => {
      console.log(error);
      setMensagem("Erro ao enviar resumo.");
    })
    .finally(() => {
      setLoading(false);
    });
  };

  return (
    <>
      <header id='header'>
        <AppHeader />
      </header>

      <BannerSection
        title="Submissão de Resumo"
        subtitle="Chamada de Trabalhos"
        description={`Contribua para o avanço do conhecimento científico no ISP-Atlântida.`}
        backgroundImage={require('../../assets/JorBanner.jpg')}
        backgroundId="instituition-Banner"
      />

      <BreadcrumbNav items={caminho} />

      <main className="px-3 px-md-5 py-2">

        <div className="row flex-row-reverse">

          <div className="col-12 col-md-4 col-lg-3 col-xl-2">
            <SidebarMenu
              title="Área Científica"
              items={[
                { label: "O que é Jornada Científica?", href: "/investigacao/jornada-cientifica" },
                { label: "Submissão de Resumo", href: "/investigacao/submissao-resumo" },
                { label: "Biblioteca virtual", href: "/investigacao/Biblioteca-virtual" },
              ]}
            />
          </div>

          <div className="col-12 col-md-8 col-lg-9 col-xl-10">

            <div className="details-magazine" id='detalhes'>

              <SectionHeading title="Submissão de Resumo" />

              <form ref={form} onSubmit={enviarFormulario}>

                <div className="mb-4">
                  <label className="form-label fw-semibold">
                    Nome do Autor *
                  </label>

                  <input
                    type="text"
                    name="nome"
                    className="form-control"
                    required
                  />
                </div>

                <div className="mb-4">
                <label className="form-label fw-semibold">
                    E-mail do Autor *
                </label>

                <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="ex: autor@email.com"
                    required
                />
                </div>

                <div className="mb-4">
                  <label className="form-label fw-semibold">
                    Grau Académico *
                  </label>

                  <select
                    name="grau"
                    className="form-select"
                    required
                  >
                    <option value="">Selecione</option>
                    <option value="Estudante">Estudante</option>
                    <option value="Licenciado">Licenciado(a)</option>
                    <option value="Mestre">Mestre</option>
                    <option value="Doutor">Doutor(a)</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="form-label fw-semibold">
                    Resumo *
                  </label>

                  <textarea
                    name="resumo"
                    rows="6"
                    className="form-control"
                    required
                  ></textarea>
                </div>

                <div className="mb-4">
                  <label className="form-label fw-semibold">
                    Instituição
                  </label>

                  <input
                    type="text"
                    name="instituicao"
                    className="form-control"
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-success w-100 py-2"
                  disabled={loading}
                >
                  {
                    loading
                    ? "Enviando..."
                    : "Enviar Resumo"
                  }
                </button>

                {
                  mensagem &&
                  <div className="alert alert-info mt-3">
                    {mensagem}
                  </div>
                }

              </form>

            </div>

          </div>

        </div>

      </main>

      <AppLayout />
    </>
  );
}

export default JornadaCientifica;


